var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWorkbench(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 2h6a1 1 0 011 1v1h2a2 2 0 012 2v14a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2h2V3a1 1 0 011-1zm.5 1.5v2h5v-2h-5zm-2 6.5a.75.75 0 100 1.5h1a.75.75 0 100-1.5h-1zm3.5 0a.75.75 0 100 1.5h5.5a.75.75 0 100-1.5H11zm-3.5 4a.75.75 0 100 1.5h1a.75.75 0 100-1.5h-1zm3.5 0a.75.75 0 100 1.5h5.5a.75.75 0 100-1.5H11z",
    fill: "#FFF"
  })));
}

export default SvgWorkbench;